import React from 'react';

const ZoomInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path d="M10.41,6.42H8V4a.79.79,0,0,0-.23-.56.82.82,0,0,0-.57-.24.82.82,0,0,0-.8.8v2.4H4a.79.79,0,0,0-.56.23.82.82,0,0,0-.24.57A.82.82,0,0,0,4,8h2.4v2.4a.82.82,0,0,0,.8.8A.82.82,0,0,0,7.78,11,.79.79,0,0,0,8,10.42V8h2.4A.82.82,0,0,0,11,7.78a.79.79,0,0,0,.23-.56.79.79,0,0,0-.8-.8Z" />
    <path d="M15.78,14.65l-3-3a7.11,7.11,0,1,0-1.11,1.12l2.94,2.94a.78.78,0,0,0,.26.17.81.81,0,0,0,.31.06.85.85,0,0,0,.31-.06,1.06,1.06,0,0,0,.26-.17A.82.82,0,0,0,16,15.2.8.8,0,0,0,15.78,14.65Zm-4.61-3.47A5.6,5.6,0,0,1,2,9.36a5.67,5.67,0,0,1-.32-3.23,5.62,5.62,0,0,1,4.4-4.4,5.49,5.49,0,0,1,3.23.32,5.6,5.6,0,0,1,1.82,9.13Z" />
  </svg>
);

export default ZoomInIcon;
